<template>
  <svg
    class="icon"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="Vector"
        d="M42.7612 30.8099C44.6893 32.3436 46.3575 33.9561 47.3227 36.1928C49.2114 40.5756 46.9329 44.144 43.3181 45.8424C39.6986 47.5431 35.861 47.7937 31.9747 47.1533C26.5756 46.2647 21.571 44.4341 17.6313 40.4341C16.1394 38.919 15.1905 37.086 15.0675 34.8842C15.8424 35.7867 16.4921 36.7891 17.3714 37.5153C19.7844 39.5083 22.7009 39.861 25.6893 39.6429C32.2067 39.1626 37.5663 36.2856 42.0118 31.5779C42.223 31.3552 42.4411 31.1371 42.7636 30.8076L42.7612 30.8099Z"
        fill="#1B1818"
      />
      <path
        id="Vector_2"
        d="M17.1926 42.7611C15.659 44.6892 14.0464 46.3574 11.8098 47.3226C7.42694 49.2112 3.8585 46.9328 2.16012 43.318C0.459426 39.6985 0.208846 35.8609 0.849217 31.9746C1.73785 26.5755 3.56847 21.5709 7.56847 17.6312C9.08356 16.1393 10.9165 15.1904 13.1184 15.0674C12.2158 15.8423 11.2135 16.492 10.4873 17.3713C8.49423 19.7843 8.14156 22.7008 8.35966 25.6892C8.83994 32.2066 11.717 37.5662 16.4246 42.0117C16.6474 42.2228 16.8655 42.4409 17.1949 42.7634L17.1926 42.7611Z"
        fill="#1B1818"
      />
      <path
        id="Vector_3"
        d="M5.23912 17.1928C3.31104 15.6592 1.64283 14.0467 0.67763 11.81C-1.20868 7.42485 1.06974 3.85872 4.68459 2.16035C8.30408 0.459649 12.1417 0.209069 16.028 0.84712C21.4271 1.73575 26.4317 3.56638 30.3714 7.56638C31.8632 9.08146 32.8122 10.9144 32.9352 13.1163C32.1602 12.2137 31.5106 11.2114 30.6312 10.4852C28.2182 8.49213 25.3018 8.13946 22.3134 8.35756C15.796 8.83784 10.4363 11.7149 5.99086 16.4225C5.77972 16.6453 5.56162 16.8634 5.23912 17.1928Z"
        fill="#1B1818"
      />
      <path
        id="Vector_4"
        d="M30.8097 5.23898C32.3433 3.31091 33.9559 1.64269 36.1925 0.677496C40.5754 -1.21114 44.1438 1.06729 45.8422 4.68214C47.5429 8.30163 47.7935 12.1392 47.1531 16.0255C46.2644 21.4246 44.4338 26.4292 40.4338 30.3689C38.9187 31.8608 37.0858 32.8097 34.8839 32.9327C35.7865 32.1578 36.7888 31.5081 37.515 30.6288C39.5081 28.2158 39.8607 25.2993 39.6426 22.3109C39.1624 15.7935 36.2853 10.4339 31.5777 5.9884C31.3549 5.77726 31.1368 5.55917 30.8074 5.23666L30.8097 5.23898Z"
        fill="#1B1818"
      />
    </g>
  </svg>
</template>
